import type { Config } from '@/adapters/primitive/_contract/config';

export function naturalFlightDurationMs(args: {
    config: Config;
    from: readonly number[];
    to: readonly number[];
}): number {
    const distance = Math.hypot(
        args.to[0] - args.from[0],
        args.to[1] - args.from[1],
        args.to[2] - args.from[2],
    );
    return (args.config.base.animation?.flightBaseDurationMs ?? 0)
        + (args.config.base.animation?.flightPerUnitDurationMs ?? 0) * distance;
}

export function naturalRotationDurationMs(args: {
    config: Config;
    slotOffset: number;
}): number {
    return (args.config.base.animation?.rotateBaseDurationMs ?? 0)
        + (args.config.base.animation?.rotatePerSlotDurationMs ?? 0) * Math.abs(args.slotOffset);
}